import color from "../../../../../../constants/color";

const style = {
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingRight: 3.5
  },
  leaveHeading: {
    fontWeight: 600,
    fontSize: "20px",
    mb: 2
  },
  btnGridAction: {
    width: "100%",
    ml: { xs: 1, md: 0 },
  },
  medicalRadioSection: {
    display: "flex",
    mt: { xs: 2, md: 0 }
  },
  gridContainer: {
    alignItems: "center",
    justifyContent: "space-between"


  },
  secondGrid: {
    ml: { xs: 0, md: 2 },
    display: "flex",
    textAlign: { xs: "left", md: "end" },
    justifyContent: { xs: "left", md: "end" },
    width: "100%"
  },
  dropdowns: {

    fontWeight: 400,
    fontSize: "12px",
    color: color.lightText

  },
  dropDownMenu: {
    fontWeight: 400,
    fontSize: "12px",

  },

  endTime: {
    ml: 2
  },
  radioGrid: {
    display: "flex",
    marginRight: '50px'
  },
  btnGrid: {
    textAlign: "end",
    mx: 1
  },
  submitButton: {
    borderRadius: 50,
    fontSize: "14px",
    fontWeight: "500",
    textTransform: "none",
    backgroundColor: color.primary,
    " & .css-1yt7yx7-MuiLoadingButton-loadingIndicator": {
      position: "unset",
    },
    "& .MuiButton-startIcon": {
      marginRight: "8px",
      marginLeft: "8px",
    },
  },
  label: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    my: 1
  },
  reason: {
    borderRadius: "18px",

    width: "100%",
    ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      py: 1
    },
  },
  formGrid: {
    display: "flex"
  },

  dateInput: {
    width: "100%",
    my: 1,


    "& .MuiInputBase-input": {
      padding: "8.5px 14px",
    }
  },

  jobButton: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: "#28AA4A",
    fontSize: "12px",
    mt: 1,
  },

  inputSection: {
    display: { xs: "block", md: "flex" },
    px: 2,
    alignItems: "center",
    justifyContent: "space-between",
    mb: 1.5,
    width: "100%"
  },
  inputCreditSection: {
    display: { xs: "block", md: "flex" },
    px: 2,
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: 'row',
    mb: 1.5,
    width: "100%"
  },
  inlineBlock: {
    display: "block",
    width: "100%",
    px: 2,
    mb: 1.5,
  },

  inputLabel: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text
  },
  addIcon: {
    p: 1,
    backgroundColor: "#D4EEDB",
    borderRadius: "5px",
    color: color.primary,
    textAlign: "center"
  },
  deleteIcon: {
    p: 1,
    // pb:0,
    backgroundColor: "#FBD6D6",
    borderRadius: "5px",
    color: color.red,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"

  },

  inputContainer: {
    // width:{xs:"18em",md:"25em",},
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between"
  },
  inputContainerBox: {
    // width:{xs:"18em",md:"25em",},
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    mb: 1,
  },

  modalInput: {
    display: "flex",    // backgroundColor:color.lightGray,
    // borderRadius:"30px",
    // width:{ xs: "25em", md: "35em" },
    justifyContent: "center",// Center align on smaller screens
    my: "10px",
    height: "2.4em",
    fontSize: "14px",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "5.5px 14px",
    },
    "& .MuiOutlinedInput-root": {
      padding: "0"
    },
    width: "250px"
  },
  selectGrid: {
    mr: 1,
  },

  uploadSection: {
    px: 2,
    width: { xs: "100%", md: "55%" },

    "& .css-2y07vr": {
      py: "7px"

    }
  },
  leaveInputGrid: {
    display: { xs: "block", md: "flex" },
    alignItems: "center",
    justifyContent: "space-between"

  },
  leaveSheetGrid: {
    display: { xs: "block", md: "flex" },
    ml: { xs: 0, md: 2 },
    mt: { xs: 0, md: 2 },
    height: "fit-content"
  },
  leaveSheet: {
    border: "1px solid rgba(0, 0, 0, 0.23)",
    borderRadius: "5px",
    px: 1,
    mr: 1,
    mb: { xs: 1, md: 0 },
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",

    " & .css-0": {
      display: "flex",

    },
  },
  closeIcon: {
    fontSize: "1rem",
    ml: 2,
  },

  inputBox: {
    width: "25%"
  },
  inputText: {
    fontSize: "14px",
    fontWeight: "400",
    color: color.text,

  },
  gridbox: {
    backgroundColor: "#ffff",
    m: 2,
    py: 4,
    px: 1,
    // mr: { xs: 3, sm: 3, md: 3, lg: 0 },
    borderRadius: "20px",
    height: "fit-content",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "end"

  },
  gridboxTime: {
    backgroundColor: "#ffff",
    m: 2,
    py: 4,
    px: 2,
    // mr: { xs: 3, sm: 3, md: 3, lg: 0 },
    borderRadius: "20px",
    // display: "flex",
    // justifyContent: "space-between",
    // alignItems: "center"


  },
  weakGrid: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mb: 1

  },

  formControlLabel: {
    display: "block",
  },
  greyLine: {
    border: "1px solid #DEDEDE",
    width: "75%",
  },
  edit: {
    backgroundColor: "#A3E1FB",
    borderRadius: "8px",
    mx: 1,
    display: "flex",
    alignItems: "center",
    width: "27px",
    height: "27px",
    justifyContent: "center",

  },
  delete: {
    backgroundColor: color.lightRed,
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    width: "27px",
    height: "27px",
    justifyContent: "center",

  },

  gridboxs: {
    backgroundColor: "#ffff",
    mt: 0,
    mx: 2,
    mb: 2,
    py: 4,
    // mr: { xs: 3, sm: 3, md: 3, lg: 0 },
    borderRadius: "20px",
    height: "fit-content",

  },

  itemSection: {
    display: "flex",
    mx: 2,
    alignItems: "center",
    width: "100%",

  },
  gridText: {
    fontSize: "14px",
    fontWeight: "600"
  },
  bioBox: {
    px: 3,
    pt: 1,
  },
  content: {
    mt: 2,
    ml: 2,
    display: "flex",
    flexDirection: "row",
    // justifyContent:"space-Between"
  },
  switchSection: {
    display: "flex",
    alignItems: "center",
    mb: 1,
  },
  mainBoxes: {
    pr: 2,
    display: "flex",
    justifyContent: "end",
    my: 2

  },
  jobButtons: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: "#28AA4A",
    fontSize: "14px",
    fontWeight: "500",
    ml: 3,
    px: 4,
  },
  mainContainers: {
    justifyContent: "end",
    // pr:{xs:1, md:1}
  },
  mainContainerPension: {
    justifyContent: "end",
    mb: 3
    // pr:{xs:1, md:1}
  },

  dropdown: {
    "& .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "8.5px 14px",
    },
    // width:{ xs: "25em", md: "35em" },
    width: "100%",
    fontSize: "14px",
    fontWeight: "400",
    mt: 1,
  },
  typeGrid: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    px: "15px",
  },
  popupBox: {
    width: "100%",
  },
  contributionsInput: {
    width: "100%"
  },
  calenderInput: {
    "& .MuiInputBase-input": {
      padding: "8.5px 14px",
      width: "250px",
    }
  },
  // Credits Table Styles from Image
  creditsHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mb: 2,
    width: "100%",
  },
  creditsTitle: {
    fontWeight: 600,
    fontSize: "18px",
    color: "#343a40",
  },
  manageButton: {
    backgroundColor: "#28a745",
    color: "#ffffff",
    padding: "8px 24px",
    borderRadius: "6px",
    fontWeight: 500,
    fontSize: "14px",
    cursor: "pointer",
    textAlign: "center",
    whiteSpace: "nowrap",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#218838",
    },
  },
  creditsTableContainer: {
    backgroundColor: "#ffffff",
    borderRadius: "10px",
    padding: "24px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
    width: "100%",
    overflow: "hidden",
  },
  creditsTable: {
    width: "100%",
  },
  creditsTableHeader: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#f2f2f2",
    fontWeight: 600,
    fontSize: "14px",
    color: "#343a40",
    padding: "12px 16px",
    borderBottom: "1px solid #dee2e6",
    borderRadius: "4px 4px 0 0",
    width: "100%",
  },
  creditsTableRow: {
    display: "flex",
    alignItems: "center",
    padding: "16px",
    borderBottom: "1px solid #dee2e6",
    fontSize: "14px",
    color: "#343a40",
    width: "100%",
    "&:hover": {
      backgroundColor: "#f8f9fa",
    },
  },
  creditsThCreditType: {
    flex: "2 1 0%",
    textAlign: "left",
  },
  creditsThMode: {
    flex: "1.5 1 0%",
    textAlign: "left",
  },
  creditsThApplicableOn: {
    flex: "2 1 0%",
    textAlign: "left",
  },
  creditsThTotalCredits: {
    flex: "1.5 1 0%",
    textAlign: "left",
    fontWeight: 600,
  },
  creditsThActions: {
    flex: "1.5 1 0%",
    textAlign: "center",
  },
  creditsTdCreditType: {
    flex: "2 1 0%",
    textAlign: "left",
  },
  creditsTdMode: {
    flex: "1.5 1 0%",
    textAlign: "left",
    textTransform: 'capitalize'
  },
  creditsTdApplicableOn: {
    flex: "2 1 0%",
    textAlign: "left",
    textTransform: 'capitalize'
  },
  creditsTdTotalCredits: {
    flex: "1.5 1 0%",
    textAlign: "left",
    fontWeight: 400,
  },
  creditsTdActions: {
    flex: "1.5 1 0%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "12px",
  },
  creditsActionIconGreen: {
    width: "24px",
    height: "24px",
    borderRadius: "4px",
    // backgroundColor: "#28a745",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  creditsActionIconBlue: {
    width: "24px",
    height: "24px",
    borderRadius: "4px",
    backgroundColor: "#007bff",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  creditsActionIconRed: {
    width: "24px",
    height: "24px",
    // borderRadius: "4px",
    // backgroundColor: "#dc3545",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

export default style;